import { render, staticRenderFns } from "./TheMyContacts.vue?vue&type=template&id=c4442dba&"
import script from "./TheMyContacts.vue?vue&type=script&lang=js&"
export * from "./TheMyContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports